export const getSiteProperties = (state: any) => state.siteProperties;
